// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"code-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18.4645 15.5352L22 11.9996L18.4645 8.46409M5.53553 15.5352L2 11.9996L5.53553 8.46409","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Code1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'code-1',
    ref,
    icon: element,
  },
));

Code1Icon.displayName = 'Code1Icon';

export default Code1Icon;
